import { Location } from 'history';
import { murmurhash } from '../lib/js/hash';
import { GlobalDocumentIds } from '../types/GlobalDocumentIds';

const THREE_HOURS = 10800000;
const SCROLL_POSITION_PREFIX = 'scrollPosition-';

/**
 * Returns the saved scroll position for the given location, or 0 if there is none.
 * Saved positions expire after three hours.
 */
export const getScrollPosition = (loc: Location): number => {
  const key = `${SCROLL_POSITION_PREFIX}${murmurhash(loc.pathname)}`;
  const scrollPosition = sessionStorage.getItem(key);
  if (scrollPosition) {
    const { top, timestamp } = JSON.parse(scrollPosition);
    const millisSinceEpoch = Date.now();

    if (millisSinceEpoch - timestamp > THREE_HOURS) {
      sessionStorage.removeItem(key);
      return 0;
    }

    return top;
  }

  return 0;
};

/**
 * Saves the current scroll position of the scroll-content element for the given location.
 */
export const saveScrollPosition = (loc: Location, storage: Storage = sessionStorage): void => {
  const key = `${SCROLL_POSITION_PREFIX}${murmurhash(loc.pathname)}`;
  const contentElement = document.getElementById(GlobalDocumentIds.scrollContent);
  const scrollPosition = { top: contentElement?.scrollTop, timestamp: Date.now() };
  storage.setItem(key, JSON.stringify(scrollPosition));
};
